import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { Seo } from './Seo';

export function NotFound() {
    const { t } = useTranslation()
    return (
        <div className="container margintp text-center" style={{ marginBottom: "100px" }}>
            <Seo title={t("Seite nicht gefunden") + " | Mimac"} noindex />
            <h3>{t("Seite nicht gefunden")}</h3>
            <Link to="/" className="btn btn-lg btn-custom">{t("Zur Startseite")}</Link>
        </div>
    )
}
